import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import sortRegions from '../../../../data/regionsSorter';
import regionOptionsOfBankruptcySearchFormMap from '../../../../maps/regionOptionsOfBankruptcySearchFormMap';

export const defaultRegionOptions = Object.keys(regionOptionsOfBankruptcySearchFormMap).map(courId => ({
  value: courId,
  label: regionOptionsOfBankruptcySearchFormMap[courId],
}));

const RegionSelector = (props) => {
  const customStyle = props.width
    ? { width: props.width }
    : {};

  return (
    <div className="region-selector-container" style={{ float: 'left' }}>
      <label className="region-selector-label" htmlFor="region-selector">Region: </label>
      <div className="region-selector">
        <Select
          style={customStyle}
          name="form-field-name"
          options={sortRegions(props.regionOptions)}
          multi
          simpleValue
          value={props.filters.get(props.courtField)}
          placeholder="All Courts"
          onChange={court_id => props.onChange({ court_id: court_id || '' })} />
      </div>
    </div>
  );
}

RegionSelector.defaultProps = {
  regionOptions: defaultRegionOptions,
  courtField: 'court_id',
  width: null,
};

RegionSelector.propTypes = {
  filters: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  regionOptions: PropTypes.any,
  courtField: PropTypes.string,
  width: PropTypes.string,
};

export default RegionSelector;



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/regionSelector/RegionSelector.js
 **/